


// asyncRouter.js
//判断当前角色是否有访问权限
export function hasPermission(route, permission) {
    if (route.meta && route.meta.auths) {
      // permission是用户拥有的权限数组
      // 判断用户权限中是否拥有页面的访问权限
      return permission.some(role => route.meta.auths.indexOf(role)!==-1)
    } else {
      return false
    }
  }
  // 递归过滤异步路由表，筛选角色权限路由
  export function filterAsyncRoutes(routes, permission) {
    const res = [];
    routes.forEach(route => {
      const tmp = { ...route }
      if (hasPermission(tmp, permission)) {  
        if (tmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children, permission)
        }
        res.push(tmp)
      }
    })
    return res
  }


// export  const dynamicRouter = [
//     {
//         path: "/usersystem",
//         redirect: "/usersystem/home",
//         component: () => import("@/views/BlankPage.vue"),
//         meta: { auths: ['APP_QUERY']},
//     },
//     {
//         path: "home",
//         component: () => import("@/views/userViews/Index.vue"),
//         meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "search",
//         component: () => import("@/views/userViews/Search.vue"),
//         meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "applydetails",
//         component: () => import("@/views/userViews/ApplyDetails.vue"),
//         meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "bookapply",
//         component: () => import("@/views/userViews/BookApply.vue"),
//         // meta: { auths: ['APP_SUBSCRIBE']},
//       },
//       {
//         path: "sellercenter",
//         component: () => import("@/views/userViews/SellerCenter.vue"),
//         meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "myapplication",
//         component: () =>
//           import("@/views/userViews/sellerCenter/MyApplication.vue"),
//           meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "noticecenter",
//         component: () =>
//           import("@/views/userViews/sellerCenter/NoticeCenter.vue"),
//           meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "noticecenter/:id",
//         component: () =>
//           import("@/views/userViews/sellerCenter/NoticeDetail.vue"),
//           meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "ordercenter",
//         component: () =>
//           import("@/views/userViews/sellerCenter/OrderCenter.vue"),
//           meta: { auths: ['APP_SUBSCRIBE']},
//       },
//       {
//         path: "ordercenter/:id",
//         component: () =>
//           import("@/views/userViews/sellerCenter/OrderDetail.vue"),
//           meta: { auths: ['APP_QUERY']},
//       },
//       {
//         path: "paidpage",
//         component: () => import("@/views/userViews/PaidPage.vue"),
//         meta: { auths: ['APP_QUERY']},
//       },

//     //   后端路由
//       {
//         path: "/backsystem",
//         redirect: "/backsystem/home",
//         component: () => import("@/views/BlankPage.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "home",
//         component: () => import("@/views/backViews/Index.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "myapplication",
//         component: () => import("@/views/backViews/MyApplication.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "myapplylist",
//         component: () => import("@/views/backViews/MyApplyList.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "noticecenter",
//         component: () => import("@/views/backViews/NoticeCenter.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "noticedetail",
//         component: () => import("@/views/backViews/NoticeDetail.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//       {
//         path: "createapply",
//         component: () => import("@/views/backViews/ApplicationForm.vue"),
//         meta: { auths: ['MGR_QUERY']},
//       },
//   ];